webpackJsonp([58],{

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ErrorPanel',
  props: {
    message: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: 'el-icon-warning-outline'
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backText: {
      type: String,
      default: '返回上一页'
    },
    backIcon: {
      type: String,
      default: 'el-icon-arrow-left'
    }
  },
  methods: {
    handleBack: function handleBack() {
      if (this.$router && this.$router.back) {
        this.$router.back();
      } else if (window && window.history) {
        window.history.back();
      }
    }
  }
});

/***/ }),

/***/ 1413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPanel_vue__ = __webpack_require__(1380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_072bf2be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPanel_vue__ = __webpack_require__(1416);
function injectStyle (ssrContext) {
  __webpack_require__(1414)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-072bf2be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ErrorPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_072bf2be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ErrorPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1415);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("62566b31", content, true, {});

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".error-panel[data-v-072bf2be]{padding:40px 20px;min-height:260px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background:#fff;border-radius:4px;-webkit-box-shadow:0 2px 12px rgba(0,0,0,.1);box-shadow:0 2px 12px rgba(0,0,0,.1);-webkit-box-sizing:border-box;box-sizing:border-box}.error-panel__icon-wrap[data-v-072bf2be]{margin-bottom:20px}.error-panel__icon[data-v-072bf2be]{font-size:64px;color:#f56c6c}.error-panel__text[data-v-072bf2be]{font-size:20px;font-weight:500;color:#303133;margin:0 0 20px;max-width:520px;line-height:1.6;word-break:break-all}.error-panel__actions[data-v-072bf2be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/workspace/src/components/ErrorPanel.vue"],"names":[],"mappings":"AACA,8BAA8B,kBAAkB,iBAAiB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,kBAAkB,gBAAgB,kBAAkB,6CAA8C,qCAAsC,8BAA8B,qBAAqB,CAC/hB,AACD,yCAAyC,kBAAkB,CAC1D,AACD,oCAAoC,eAAe,aAAa,CAC/D,AACD,oCAAoC,eAAe,gBAAgB,cAAc,gBAAkB,gBAAgB,gBAAgB,oBAAoB,CACtJ,AACD,uCAAuC,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,sBAAsB,CAC9J","file":"ErrorPanel.vue","sourcesContent":["\n.error-panel[data-v-072bf2be]{padding:40px 20px;min-height:260px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background:#fff;border-radius:4px;-webkit-box-shadow:0 2px 12px rgba(0,0,0,0.1);box-shadow:0 2px 12px rgba(0,0,0,0.1);-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.error-panel__icon-wrap[data-v-072bf2be]{margin-bottom:20px\n}\n.error-panel__icon[data-v-072bf2be]{font-size:64px;color:#F56C6C\n}\n.error-panel__text[data-v-072bf2be]{font-size:20px;font-weight:500;color:#303133;margin:0 0 20px 0;max-width:520px;line-height:1.6;word-break:break-all\n}\n.error-panel__actions[data-v-072bf2be]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-panel"},[(_vm.showIcon)?_c('div',{staticClass:"error-panel__icon-wrap"},[_c('i',{class:[_vm.iconClass, 'error-panel__icon']})]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"error-panel__text"},[_vm._t("default",[_vm._v(_vm._s(_vm.message))])],2),_vm._v(" "),(_vm.showBack || _vm.$slots.actions)?_c('div',{staticClass:"error-panel__actions"},[_vm._t("actions",[(_vm.showBack)?_c('el-button',{attrs:{"type":"primary","icon":_vm.backIcon},on:{"click":_vm.handleBack}},[_vm._v("\n        "+_vm._s(_vm.backText)+"\n      ")]):_vm._e()])],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assocFormRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return searchManualSaveTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return returnForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return completeForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {};

var formRules = {
  customerid: [{ required: true, message: '客户ID不能为空', trigger: 'blur' }],
  receipt_info_id: [{ required: true, message: '抬头不能为空', trigger: 'blur' }],
  desc: [{ required: true, message: '申请描述不能为空', trigger: 'blur' }],
  type: [{ required: true, message: '发票类别不能为空', trigger: 'blur' }],
  subject: [{ required: true, message: '开票主体不能为空', trigger: 'blur' }],
  currency_type: [{ required: true, message: '币种不能为空', trigger: 'blur' }],
  bd: [{ required: true, message: '预收款开票 bd 不能为空', trigger: 'blur' }],
  bu_approver: [{ required: true, message: 'BU审批不能为空', trigger: 'blur' }],
  attached_file: [{ required: true, message: '附件不能为空', trigger: 'blur' }],
  po_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入30字以内的单号', 'string', 'blur', false), { max: 29 })],
  pay_condition_id: [{ required: true, message: '请选择账期', trigger: 'blur' }]
};

var assocFormRules = {
  id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择回款', 'integer'))],
  assoc_amount: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入回款金额', 'string'))]
};

var searchManualSaveTicket = {
  fpdm: [{ required: true, message: '发票代码不能为空', trigger: 'blur' }],
  fphm: [{ required: true, message: '发票号码不能为空', trigger: 'blur' }],
  kprq: [{ required: true, message: '开票日期不能为空', trigger: 'blur' }]
};

var returnForm = {
  isCurrentMonth: [{ required: true, message: '请选择是否当月发票', trigger: 'blur' }],
  reason: [{ required: true, message: '退票原因不能为空', trigger: 'blur' }],
  redAttachedFile: [{ required: true, message: '红冲发票附件不得为空', trigger: 'blur' }]
};

var completeForm = {
  invoice_number: [{ required: true, message: '发票号码不能为空', trigger: 'blur' }, { max: 255, message: '发票号码不得大于255个字符', trigger: 'blur' }],
  invoice_code: [{ required: true, message: '发票代码不能为空', trigger: 'blur' }, { max: 255, message: '发票代码不得大于255个字符', trigger: 'blur' }],
  invoice_time: [{ required: true, message: '开票日期不得为空', trigger: 'blur' }],
  e_invoice_url: [{ required: true, message: '电子发票链接不得为空', trigger: 'blur' }]
};

/***/ }),

/***/ 1455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/*
 * ElementUI 下拉远程搜索
 * @Author: anker.wang
 * @Date: 2018-02-08 13:26:37
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-02-08 13:27:08
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectLoading: false
    };
  },

  methods: {
    selectRemoteMethod: function selectRemoteMethod(query, request, callback, params) {
      var _this = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          request(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ keyword: query }, params)).then(function (response) {
            callback(response.data);
          }).finally(function () {
            _this.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    }
  }
});

/***/ }),

/***/ 1508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = regType;
/**
 * 正则验证方法库
 */
function regType(type) {
  var exp = void 0;

  switch (type) {
    default:
      exp = new RegExp();
      break;
    case 'number':
      // 纯数字
      exp = /^\d+$/gi;
      break;
    case 'email':
      // 邮箱
      exp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/gi;
      break;
    case 'httpUrl':
      // HTTP/HTTPS URL
      exp = /^(http|https):\/\/([0-9a-z_!~*'()-]+\.)*(([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.)([a-z]{2,6})((\/?)|(\/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+(\/?))$/gi;
      break;
    case 'telephone':
      // 手机
      exp = /^1[3456789]\d{9}$/gi;
      break;
    case 'phone':
      // 座机
      exp = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/gi;
      break;
    case 'imgData':
      // data-url图片
      exp = /^data:image\//gi;
      break;
    case 'money':
      // 金额
      exp = /^(\d+)((\.){1,1}(\d){1,2})?$/g;
      break;
  }

  return exp;
}

/***/ }),

/***/ 1687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_to_formdata__ = __webpack_require__(1945);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SjUploadModal',
  props: {
    title: {
      type: String,
      default: '上传'
    },
    tip: {
      type: String,
      default: ''
    },
    fileExtension: {
      type: String,
      default: ''
    },
    fileMaxSize: {
      type: Number,
      default: 0
    },
    fileMinSize: {
      type: Number,
      default: 0
    },
    validateFile: {
      type: Boolean,
      default: false
    },
    request: {
      type: String,
      required: true,
      default: ''
    },
    requestData: Object,
    showClearBtn: {
      type: Boolean,
      default: true
    },
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    validatesDesc: function validatesDesc() {
      var items = [];
      if (this.validateFile) {
        if (this.fileExtension) {
          items.push(this.validationStrings.extension = '\u5FC5\u987B\u4E3A' + this.fileExtension + '\u6587\u4EF6');
        }
        if (this.fileMaxSize) {
          var humanSize = Math.round(this.fileMaxSize / 1024 / 1024) + 'Mb';
          items.push(this.validationStrings.maxSize = '\u6587\u4EF6\u4E0D\u80FD\u5927\u4E8E' + humanSize);
        }
        if (this.fileMinSize) {
          var _humanSize = Math.round(this.fileMinSize / 1024 / 1024) + 'Mb';
          items.push(this.validationStrings.minSize = '\u6587\u4EF6\u4E0D\u80FD\u5C0F\u4E8E' + _humanSize);
        }
      }
      return items;
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val === false) {
        this.result = null;
        this.uploaded = null;
        this.onUploading = false;
        this.$refs.upload.clearFiles();
      }
    },
    files: function files(val) {
      this.fileList = val;
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      onUploading: false,
      params: null,
      result: null,
      validationStrings: {
        extension: '',
        maxSize: '',
        minSize: ''
      },
      uploaded: false,
      fileList: []
    };
  },

  methods: {
    open: function open(params) {
      this.params = params;
      this.dialogVisible = true;
    },
    upload: function upload(file) {
      var _this = this;

      var formFile = file.raw;
      if (this.validateFile) {
        if (this.fileExtension.length > 0 && _.endsWith(formFile.name, '.' + this.fileExtension) === false) {
          return this.validateFailed(this.validationStrings.extension);
        }
        if (this.fileMaxSize > 0 && formFile.size > this.fileMaxSize) {
          return this.validateFailed(this.validationStrings.maxSize);
        }
        if (this.fileMinSize > 0 && formFile.size < this.fileMinSize) {
          return this.validateFailed(this.validationStrings.minSize);
        }
      }

      var formData = Object(__WEBPACK_IMPORTED_MODULE_0_object_to_formdata__["a" /* default */])(this.requestData);
      formData.append('file', formFile);
      this.onUploading = true;

      return request.common(this.request, formData).then(function (_ref) {
        var data = _ref.data;

        if (typeof data === 'string') {
          _this.result = {
            url: data,
            name: formFile.name
          };
        } else {
          _this.result = data;
        }
        _this.uploaded = true;
        _this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
      }).catch(function () {
        _this.$refs.upload.clearFiles();
      }).finally(function () {
        _this.onUploading = false;
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.result = null;
      this.fileList = fileList;
    },
    submit: function submit() {
      this.dialogVisible = false;
      if (this.uploaded) {
        this.$emit('uploaded', this.result, this.params);
      } else if (!this.fileList.length) {
        this.$emit('uploaded', null, this.params);
      }
    },
    clear: function clear() {
      var _this2 = this;

      this.$confirm('你确定需要清除已上传的文件吗？', '提示', { type: 'warning' }).then(function () {
        _this2.dialogVisible = false;
        _this2.$emit('uploaded', null, _this2.params);
      });
    },
    validateFailed: function validateFailed(why) {
      this.$message.error(why);
      this.$refs.upload.clearFiles();
    },
    onExceed: function onExceed() {
      this.$message.error('文件数量超出限制');
    }
  }
});

/***/ }),

/***/ 1942:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjUploadModal_vue__ = __webpack_require__(1687);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1555a1b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjUploadModal_vue__ = __webpack_require__(1946);
function injectStyle (ssrContext) {
  __webpack_require__(1943)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1555a1b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SjUploadModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1555a1b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SjUploadModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1943:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1944);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0bd43252", content, true, {});

/***/ }),

/***/ 1944:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".upload-file-modal[data-v-1555a1b2] .el-dialog{width:30%;min-width:400px}", "", {"version":3,"sources":["/workspace/src/components/sj-upload-modal/SjUploadModal.vue"],"names":[],"mappings":"AACA,+CAA+C,UAAU,eAAe,CACvE","file":"SjUploadModal.vue","sourcesContent":["\n.upload-file-modal[data-v-1555a1b2] .el-dialog{width:30%;min-width:400px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = i;
function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(n){return typeof n}:function(n){return n&&"function"==typeof Symbol&&n.constructor===Symbol&&n!==Symbol.prototype?"symbol":typeof n})(e)}var e=function(n){return void 0===n},t=function(n){return Array.isArray(n)},o=function(n){return n&&"number"==typeof n.size&&"string"==typeof n.type&&"function"==typeof n.slice};function i(r,f,u,s){if((f=f||{}).indices=!e(f.indices)&&f.indices,f.nullsAsUndefineds=!e(f.nullsAsUndefineds)&&f.nullsAsUndefineds,u=u||new FormData,e(r))return u;if(null===r)f.nullsAsUndefineds||u.append(s,"");else if(t(r))if(r.length)r.forEach((function(n,e){var t=s+"["+(f.indices?e:"")+"]";i(n,f,u,t)}));else{var l=s+"[]";u.append(l,"")}else!function(n){return n instanceof Date}(r)?!function(n){return n===Object(n)}(r)||function(e){return o(e)&&"string"==typeof e.name&&("object"===n(e.lastModifiedDate)||"number"==typeof e.lastModified)}(r)||o(r)?u.append(s,r):Object.keys(r).forEach((function(n){var e=r[n];if(t(e))for(;n.length>2&&n.lastIndexOf("[]")===n.length-2;)n=n.substring(0,n.length-2);i(e,f,u,s?s+"["+n+"]":n)})):u.append(s,r.toISOString());return u}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 1946:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-file-modal"},[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('el-upload',{ref:"upload",attrs:{"drag":"","action":"","limit":1,"on-exceed":_vm.onExceed,"auto-upload":false,"file-list":_vm.fileList,"show-file-list":true,"on-remove":_vm.handleRemove,"on-change":_vm.upload}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将文件拖到此处，或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_c('ul',[(_vm.tip)?_c('li',[_vm._v(_vm._s(_vm.tip))]):_vm._e(),_vm._v(" "),_vm._l((_vm.validatesDesc),function(item){return (_vm.validateFile)?_c('li',[_vm._v("\n            "+_vm._s(item)+"\n          ")]):_vm._e()})],2)])]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[(_vm.showClearBtn)?_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":_vm.clear}},[_vm._v("清 除")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","size":"small","disabled":_vm.onUploading},on:{"click":_vm.submit}},[_vm._v("确 定")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2175:
/***/ (function(module, exports, __webpack_require__) {

/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/
(function(e,g){ true?module.exports=g():"function"===typeof define&&define.amd?define(g):(e=e||self,e.currency=g())})(this,function(){function e(b,a){if(!(this instanceof e))return new e(b,a);a=Object.assign({},m,a);var d=Math.pow(10,a.precision);this.intValue=b=g(b,a);this.value=b/d;a.increment=a.increment||1/d;a.groups=a.useVedic?n:p;this.s=a;this.p=d}function g(b,a){var d=2<arguments.length&&void 0!==arguments[2]?arguments[2]:!0;var c=a.decimal;
var h=a.errorOnInvalid,k=a.fromCents,l=Math.pow(10,a.precision),f=b instanceof e;if(f&&k)return b.intValue;if("number"===typeof b||f)c=f?b.value:b;else if("string"===typeof b)h=new RegExp("[^-\\d"+c+"]","g"),c=new RegExp("\\"+c,"g"),c=(c=b.replace(/\((.*)\)/,"-$1").replace(h,"").replace(c,"."))||0;else{if(h)throw Error("Invalid Input");c=0}k||(c=(c*l).toFixed(4));return d?Math.round(c):c}var m={symbol:"$",separator:",",decimal:".",errorOnInvalid:!1,precision:2,pattern:"!#",negativePattern:"-!#",format:function(b,
a){var d=a.pattern,c=a.negativePattern,h=a.symbol,k=a.separator,l=a.decimal;a=a.groups;var f=(""+b).replace(/^-/,"").split("."),q=f[0];f=f[1];return(0<=b.value?d:c).replace("!",h).replace("#",q.replace(a,"$1"+k)+(f?l+f:""))},fromCents:!1},p=/(\d)(?=(\d{3})+\b)/g,n=/(\d)(?=(\d\d)+\d\b)/g;e.prototype={add:function(b){var a=this.s,d=this.p;return e((this.intValue+g(b,a))/(a.fromCents?1:d),a)},subtract:function(b){var a=this.s,d=this.p;return e((this.intValue-g(b,a))/(a.fromCents?1:d),a)},multiply:function(b){var a=
this.s;return e(this.intValue*b/(a.fromCents?1:Math.pow(10,a.precision)),a)},divide:function(b){var a=this.s;return e(this.intValue/g(b,a,!1),a)},distribute:function(b){var a=this.intValue,d=this.p,c=this.s,h=[],k=Math[0<=a?"floor":"ceil"](a/b),l=Math.abs(a-k*b);for(d=c.fromCents?1:d;0!==b;b--){var f=e(k/d,c);0<l--&&(f=f[0<=a?"add":"subtract"](1/d));h.push(f)}return h},dollars:function(){return~~this.value},cents:function(){return~~(this.intValue%this.p)},format:function(b){var a=this.s;return"function"===
typeof b?b(this,a):a.format(this,Object.assign({},a,b))},toString:function(){var b=this.s,a=b.increment;return(Math.round(this.intValue/this.p/a)*a).toFixed(b.precision)},toJSON:function(){return this.value}};return e});


/***/ }),

/***/ 2760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sj_upload_modal__ = __webpack_require__(4414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ErrorPanel_vue__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_mixins_selectRemote__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_regExp__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_currency_js__ = __webpack_require__(2175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_currency_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_currency_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__invoice_apply_rules_js__ = __webpack_require__(1419);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var RMB = function RMB(value) {
  return __WEBPACK_IMPORTED_MODULE_10_currency_js___default()(value);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__core_mixins_selectRemote__["a" /* default */]],
  components: { SjUploadModal: __WEBPACK_IMPORTED_MODULE_6__components_sj_upload_modal__["a" /* default */], ErrorPanel: __WEBPACK_IMPORTED_MODULE_7__components_ErrorPanel_vue__["a" /* default */] },
  data: function data() {
    return {
      id: 0,
      showErrorMsg: true,
      detailErrorMsg: '',
      adminInfo: {},
      fullPaymentCompanyList: {},
      subjectErrorMessage: '',
      multipleLimit: 30,
      fileList: [],
      deductionFileList: [],
      formRules: __WEBPACK_IMPORTED_MODULE_11__invoice_apply_rules_js__["c" /* formRules */],
      selectLoading: false,
      customerItems: [],
      adminuserItems: [],
      projectItems: [],
      receiptOptions: [],
      form: {
        name: '',
        receipt_info_id: null,
        pay_condition_id: null,
        customerid: '',
        issued_type: 1, // 默认值:常规发票
        desc: '',
        type: 4, // 默认值：电子发票(增值税专用发票)
        subject: '',
        currency_type: 1, // 默认值：人民币
        bd: '',
        bu_approver: '',
        cc: [],
        po_number: '',
        memo: '',
        invoice_tax_type: null,
        invoice_remark: '',
        attached_file: [],
        tax_type: 1,
        detail: [this.defaultDetailObj()],
        deduction_detail: []
      },
      receiptInfo: {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null
      },
      receiptInfoList: [],
      symbol: '￥',
      availableSubjects: [],
      costTypeOptions: [],
      collectConditionOptions: [],
      reportFiles: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.invoiceApply.options;
    },
    statusEnum: function statusEnum(state) {
      return state.customerProjectcost.statusEnum;
    },
    user: function user(state) {
      return state.login.user;
    }
  }), {
    taxed_total_amount: {
      get: function get() {
        var taxedTotalAmount = 0;
        for (var i = 0; i < this.form.detail.length; i++) {
          taxedTotalAmount = taxedTotalAmount + Number(this.form.detail[i].total);
        }
        return _.round(taxedTotalAmount, 2); // taxedTotalAmount.toFixed(2)
      }
    },
    tax_total_amount: function tax_total_amount() {
      return this.form.detail.map(function (item) {
        return item.total - item.untaxed_amount;
      }).reduce(function (total, current) {
        return total + current;
      }, 0);
    },

    untaxed_total_amount: {
      get: function get() {
        var untaxedTotalAmount = 0;
        for (var i = 0; i < this.form.detail.length; i++) {
          untaxedTotalAmount = untaxedTotalAmount + Number(this.form.detail[i].untaxed_amount);
        }
        return _.round(untaxedTotalAmount, 2); // untaxedTotalAmount.toFixed(2)
      }
    },
    isPreReceived: function isPreReceived() {
      return this.form.issued_type === 2;
    }
  }),
  watch: {
    'form.receipt_info_id': function formReceipt_info_id(newValue, oldValue) {
      // 判断 receipt_info_id 是否发生了变化，减少对接口无意义的调用
      if (this.form.receipt_info_id && newValue * 1 !== oldValue * 1) {
        this.getReceiptInfo();
        this.setPayConditions();
      }
    },
    'form.currency_type': function formCurrency_type() {
      var _this = this;

      this.options.currency_type.forEach(function (option) {
        if (option.value === _this.form.currency_type) {
          _this.symbol = option.symbol;
        }
      });
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getCustomerTable', 'getPlatformUsersIndex', 'getProjectTable', 'getCustomerDetail', 'getProjectDetail', 'getPlatformUsersDetail', 'getReceiptVirtualProjectTable', 'getReceiptVirtualProjectDetail']), {
    onLoad: function onLoad() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.getMeDetail(_this2.user.id);

              case 2:
                if (!_this2.showErrorMsg) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return _this2.getFinCenterConfigs();

              case 6:
                if (!_this2.showErrorMsg) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:

                _this2.setInvoiceNameOption();
                if (_this2.$route.params.id) {
                  _this2.setForm(_this2.id = _this2.$route.params.id);
                } else {
                  _this2.setConfig();
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
      this.onLoad();
    },
    setConfig: function setConfig() {
      var _this3 = this;

      request.common('getInvoiceApplyDefaultConfig', {}).then(function (_ref) {
        var data = _ref.data;

        _this3.form.cc = data.cc.map(function (item) {
          return item * 1;
        });
      });
    },
    getMeDetail: function getMeDetail(id) {
      var _this4 = this;

      return this.getPlatformUsersDetail({ id: id }).then(function (_ref2) {
        var data = _ref2.data;

        if (!Array.isArray(data.company_ids) || data.company_ids.length === 0) {
          _this4.detailErrorMsg = '您的账号尚未配置所属公司主体，无法使用开票申请/修改功能。请联系管理员为您配置所属公司主体';
          _this4.showErrorMsg = true;
        } else {
          _this4.adminInfo = data;
          _this4.adminInfo.company_ids = data.company_ids.map(function (item) {
            return item * 1;
          });
          _this4.showErrorMsg = false;
        }
      }).catch(function (error) {
        _this4.detailErrorMsg = '获取用户信息失败' + error;
        _this4.showErrorMsg = true;
      });
    },
    getFinCenterConfigs: function getFinCenterConfigs() {
      var _this5 = this;

      return request.common('getFinCenterConfigs').then(function (_ref3) {
        var data = _ref3.data;

        var allSource = data.payment_apply_our_company_source.map(function (item) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, item, { id: item.id * 1 });
        });
        _this5.fullPaymentCompanyList = allSource.reduce(function (acc, item) {
          acc[item.id] = item;
          return acc;
        }, {});
        _this5.availableSubjects = allSource.filter(function (item) {
          return !item.is_disabled && _this5.adminInfo.company_ids.includes(item.id);
        });
        if (_this5.availableSubjects.length === 0) {
          _this5.detailErrorMsg = '您的账号配置的所属公司主体已被全部禁用，无法使用开票申请/修改功能。请联系管理员启用对应公司主体，或为您重新分配可用的公司主体';
          _this5.showErrorMsg = true;
        } else {
          _this5.showErrorMsg = false;
        }
      });
    },
    setInvoiceNameOption: function setInvoiceNameOption() {
      var _this6 = this;

      return request.common('allEnabledInvoiceName').then(function (_ref4) {
        var data = _ref4.data;

        _this6.costTypeOptions = data;
      });
    },
    getRemoteSelectVirtualProjectInfo: function getRemoteSelectVirtualProjectInfo(_ref5) {
      var _this7 = this;

      var id = _ref5.id;

      if (!this.form.customerid) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({ data: [] });
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        request.common('getReceiptVirtualProjectDetail', { id: id, customerid: _this7.form.customerid }).then(function (_ref6) {
          var data = _ref6.data;

          if (data) {
            resolve({
              data: data
            });
          } else {}
        });
      });
    },
    setForm: function setForm(id) {
      var _this8 = this;

      request.page('getInvoiceApplyDetail', { id: id }).then(function (_ref7) {
        var data = _ref7.data;

        filter.setLoop(_this8.form, data);
        // 校验 subject 是否在 fullPaymentCompanyList 中且未被禁用，以及在当前账号配置的所属开票主体中
        _this8.subjectErrorMessage = '';
        if (_this8.form.subject) {
          var company = _this8.fullPaymentCompanyList[_this8.form.subject];
          if (!company || company.is_disabled) {
            _this8.subjectErrorMessage = '\u5F53\u524D\u5F00\u7968\u4E3B\u4F53\u3010' + (company ? company.name : '') + '\u3011\u5DF2\u88AB\u7981\u7528\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9';
            _this8.form.subject = null;
          } else if (!_this8.adminInfo.company_ids.includes(_this8.form.subject)) {
            // 如果开票主体不在当前账号配置的所属开票主体中，则清空选择并设置提示信息
            _this8.subjectErrorMessage = '\u5F53\u524D\u5F00\u7968\u4E3B\u4F53\u3010' + (company ? company.name : '') + '\u3011\u4E0D\u5728\u60A8\u8D26\u53F7\u7684\u6240\u5C5E\u5F00\u7968\u4E3B\u4F53\u4E2D\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9';
            _this8.form.subject = null;
          }
        }
        // 修复抄送人只显示 id 的bug
        _this8.form.cc = _this8.form.cc.map(function (value) {
          return value * 1;
        });
        // this.form.detail = this.form.detail.map((value) => {
        //   value.virtual_project_id = value.virtual_project_id
        //   return value
        // })
        // 修复客户名称只显示 id 的bug
        _this8.form.customerid = String(_this8.form.customerid);
        // 获取开票信息
        // 如果有receipt id 就获取  没有就拿默认的
        if (data.receipt_info_id > 0) {
          _this8.getReceiptInfo();
        } else {
          _this8.onChangeCustomerId();
        }

        var _loop = function _loop(i) {
          // 获取项目成本和项目预算
          if (_this8.form.detail[i].projectid) {
            _this8.form.detail[i].tax_type = _this8.form.detail[i].tax_type ? _this8.form.detail[i].tax_type : '';
            request.common('getInvoiceProjectFinance', { id: _this8.form.detail[i].projectid }).then(function (res) {
              _this8.$set(_this8.form.detail[i], 'budget', _.round(Number(res.data.total_budget), 2)); // Number(res.data.budget).toFixed(2)
              _this8.$set(_this8.form.detail[i], 'cost', _.round(Number(res.data.cost), 2)); // Number(res.data.cost).toFixed(2)
              if (res.data.complete_rate > 0) {
                _this8.$set(_this8.form.detail[i], 'complete_rate', _.round(Number(res.data.complete_rate), 2)); // Number(res.data.complete_rate).toFixed(2)
                _this8.form.detail[i].modifyRate = false;
              } else {
                _this8.form.detail[i].modifyRate = true;
              }
            });
            // 修正修改开票信息时，项目名称/编号 显示id的bug
            _this8.form.detail[i].projectid = String(_this8.form.detail[i].projectid);
          }
        };

        for (var i = 0; i < _this8.form.detail.length; i++) {
          _loop(i);
        }
        _this8.fileList = _this8.form.attached_file;

        // 修复抵扣项目编号 id 问题
        _this8.form.deduction_detail.forEach(function (item) {
          item.project_id = String(item.project_id);
        });

        // 剔除禁用的 主体 和 开票名称
        var availableSubjects = _this8.availableSubjects.map(function (item) {
          return item.id;
        });
        if (!availableSubjects.includes(_this8.form.subject)) {
          _this8.form.subject = null;
        }

        var costTypeOptions = _this8.costTypeOptions.map(function (item) {
          return item.id;
        });
        _this8.form.detail.forEach(function (detailItem) {
          if (!costTypeOptions.includes(detailItem.cost_type)) {
            detailItem.cost_type = null;
          }
        });
      });
    },
    changeIssuedType: function changeIssuedType() {
      if (this.isPreReceived) {
        this.form.detail = [this.defaultDetailObj()];
        if (this.form.customerid) {
          this.form.detail[0].virtual_project_id = 0;
        }
      }
    },
    getForm: function getForm() {
      return filter.copyJson(this.form);
    },
    onSubmit: function onSubmit() {
      var _this9 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (!_this9.checkSubmit()) return;
          _this9.id ? _this9.update(_this9.id) : _this9.create();
        } else {
          _this9.$message.error('提交内容填写不正确！');
        }
      });
    },
    getReceiptInfo: function getReceiptInfo() {
      var _this10 = this;

      if (this.form.customerid > 0) {
        var id = this.form.customerid;
        request.page('getCustomerReceiptOptions', { customerid: id }).then(function (_ref8) {
          var data = _ref8.data;

          _this10.receiptOptions = data;
        });
      }
      request.page('getReceiptInfo', { id: this.form.receipt_info_id }).then(function (_ref9) {
        var data = _ref9.data;

        if (data.deleted_at === null) {
          filter.setLoop(_this10.receiptInfo, data);
        } else {
          _this10.form.receipt_info_id = null;
        }
      });
    },
    setPayConditions: function setPayConditions() {
      var _this11 = this;

      request.page('getReceiptInfoCollectList', { id: this.form.receipt_info_id }).then(function (_ref10) {
        var data = _ref10.data;

        _this11.collectConditionOptions = data.filter(function (item) {
          return item.is_disabled < 1;
        });
      });
    },
    create: function create() {
      var _this12 = this;

      request.common('createInvoiceApplyData', this.getForm()).then(function (res) {
        _this12.$confirm(_this12.$route.meta.title + '成功, 是否继续添加？', '提示', { type: 'success' }).then(function () {
          _this12.onReload();
        }, function () {
          _this12.$router.back();
        });
      });
    },
    update: function update(id) {
      var _this13 = this;

      request.common('updateInvoiceApplyData', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({ id: id }, this.getForm())).then(function (res) {
        _this13.$confirm(_this13.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this13.$router.back();
        });
      });
    },
    adminuserRemoteMethod: function adminuserRemoteMethod(query) {
      var _this14 = this;

      if (query !== '') {
        this.selectLoading = true;
        setTimeout(function () {
          _this14.getPlatformUsersIndex({ name: query }).then(function (response) {
            _this14.adminuserItems = response.data.data;
          }).finally(function () {
            _this14.selectLoading = false;
          });
        }, 200);
      } else {
        this.rawCustomerItems = [];
      }
    },
    onChangeCustomerId: function onChangeCustomerId() {
      var _this15 = this;

      this.receiptOptions = [];
      this.collectConditionOptions = [];
      this.form.pay_condition_id = null;
      if (this.form.customerid > 0) {
        var id = this.form.customerid;
        request.page('getCustomerReceiptOptions', { customerid: id }).then(function (_ref11) {
          var data = _ref11.data;

          _this15.receiptOptions = data;
          _this15.resetReceiptInfo();
          data.forEach(function (option) {
            if (option.default === 1) {
              _this15.form.receipt_info_id = option.value;
            }
          });
        });
      } else {
        this.form.receipt_info_id = null;
        this.receiptInfo = {
          customerid: null,
          company_name: null,
          tax_number: null,
          bank_info: null,
          address_phone: null
        };
      }
      // 清空所选项目
      for (var i = 0; i < this.form.detail.length; i++) {
        // 获取项目成本和项目预算
        if (this.form.detail[i].projectid) {
          this.form.detail[i].projectid = '';
        }
      }
      // 清空所选项目
      for (var _i = 0; _i < this.form.deduction_detail.length; _i++) {
        this.form.deduction_detail[_i].project_id = '';
      }
      if (this.isPreReceived) {
        this.$refs['virtual'][0].emptyOptions();
        this.form.detail[0].virtual_project_id = 0;
        this.$refs['virtual'][0].setOption('0');
      }
    },
    resetReceiptInfo: function resetReceiptInfo() {
      this.form.receipt_info_id = null;
      this.receiptInfo = {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null
      };
    },
    onAddDetail: function onAddDetail() {
      this.form.detail.push(this.defaultDetailObj());
    },
    handleExceed: function handleExceed(files, fileList, max) {
      this.$message.warning('\u5F53\u524D\u9650\u5236\u9009\u62E9 ' + max + ' \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ' + files.length + ' \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ' + (files.length + fileList.length) + ' \u4E2A\u6587\u4EF6');
    },
    onChangeFile: function onChangeFile(file, fileList, formField) {
      var isLt5M = file.raw.size / 1024 / 1024 < 50;
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!');
        this.$refs.upload.uploadFiles.pop();
        return false;
      }
      this.onUploadFile(file.raw, fileList, formField);
    },
    onUploadFile: function onUploadFile(file, fileList, formField) {
      var _this16 = this;

      var formData = new FormData();
      formData.append('file', file);
      return request.alert('uploadInvoiceApplyFile', formData).then(function (_ref12) {
        var data = _ref12.data;

        _this16.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        });
        var index = _this16.getFileListIndex(file, fileList);

        var type = void 0;
        if (file.name.substr(-5).toLowerCase() === '.jpeg' || file.name.substr(-4).toLowerCase() === '.jpg' || file.name.substr(-4).toLowerCase() === '.png') {
          type = 'pic';
        } else if (file.name.substr(-4).toLowerCase() === '.pdf') {
          type = 'pdf';
        } else if (file.name.substr(-4).toLowerCase() === '.eml' || file.name.substr(-5).toLowerCase() === '.html' || file.name.substr(-4).toLowerCase() === '.htm') {
          type = 'eml';
        } else if (file.name.substr(-5).toLowerCase() === '.docx' || file.name.substr(-5).toLowerCase() === '.xlsx' || file.name.substr(-4).toLowerCase() === '.doc') {
          type = 'office';
        } else if (file.name.substr(-4).toLowerCase() === '.zip') {
          type = 'zip';
        }
        if (index > -1) {
          fileList[index].status = 'success';
          formField[index] = { name: file.name, url: data, type: type };
        }
      }).catch(function (_) {
        _this16.$refs.upload.uploadFiles.pop();
      });
    },
    getFileListIndex: function getFileListIndex(file, fileList) {
      for (var i = 0; i < fileList.length; i++) {
        var fileTemp = void 0;
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw;
        } else {
          fileTemp = fileList[i];
        }
        if (file === fileTemp) {
          return i;
        }
      }
      return -1;
    },
    beforeRemove: function beforeRemove(file, fileList, formField) {
      var fileTemp = void 0;
      if (file.raw) {
        fileTemp = file.raw;
      } else {
        fileTemp = file;
      }
      var index = this.getFileListIndex(fileTemp, fileList);
      if (index > -1) {
        formField.splice(index, 1);
      }
    },
    onDelItem: function onDelItem(index) {
      if (this.form.detail.length === 1) {
        this.$alert('开票项目信息最少为一个', '提示', {
          type: 'error'
        });
      } else {
        this.form.detail.splice(index, 1);
      }
    },
    onAddDeductionDetail: function onAddDeductionDetail() {
      var params = {
        project_id: '',
        deduction_amount: 0,
        attached_file: []
      };
      this.form.deduction_detail.push(params);
    },
    onDelDeductionItem: function onDelDeductionItem(index) {
      this.form.deduction_detail.splice(index, 1);
    },
    isDeductionItemDisabled: function isDeductionItemDisabled(detailItem) {
      // 抵扣条目的状态见 deduction_detail_status 数组,条目处于非待审核状态时，禁用编辑删除功能
      return detailItem.status && detailItem.status * 1 !== 1;
    },
    changeProject: function changeProject(projectid, index) {
      var _this17 = this;

      if (projectid) {
        request.common('getInvoiceProjectFinance', { id: projectid }).then(function (res) {
          _this17.form.detail[index].budget = _.round(Number(res.data.total_budget), 2); // Number(res.data.budget).toFixed(2)
          _this17.form.detail[index].cost = _.round(Number(res.data.cost), 2); // Number(res.data.cost).toFixed(2)
          if (res.data.complete_rate > 0) {
            _this17.form.detail[index].complete_rate = _.round(Number(res.data.complete_rate), 2); // Number(res.data.complete_rate).toFixed(2)
            _this17.form.detail[index].modifyRate = false;
          } else {
            _this17.form.detail[index].complete_rate = '';
            _this17.form.detail[index].modifyRate = true;
          }
        });
      } else {
        this.form.detail[index].budget = 0;
        this.form.detail[index].cost = 0;
        this.form.detail[index].complete_rate = '';
        this.form.detail[index].modifyRate = true;
      }
    },

    // 同步税率，使用选择的开票名称税率
    changeCostType: function changeCostType(id, index) {
      var invoiceName = this.costTypeOptions.find(function (item) {
        return item.id === id;
      });
      this.form.detail[index].tax_rate = invoiceName.tax_rate;
      if (this.form.invoice_tax_type === 1) {
        this.computeUntaxedAmount(index, invoiceName.tax_rate, this.form.detail[index].total);
      }
      if (this.form.invoice_tax_type === 2) {
        this.computeTotal(index, invoiceName.tax_rate, this.form.detail[index].untaxed_amount);
      }
    },

    /* 验证项目内开票的信息 */
    checkSubmit: function checkSubmit() {
      if (!this.adminInfo.company_ids.includes(this.form.subject)) {
        this.$message.error('所选开票主体不在您账号配置的所属开票主体中');
        return false;
      }

      if (this.isPreReceived && this.form.detail.length > 1) {
        this.$message.error('预收款发票仅允许添加一条开票项目信息');
        return false;
      }
      if (this.taxed_total_amount * 1 === 0) {
        this.$message.error('价税合计总计金额不能为 0');
        return false;
      }
      for (var i = 0; i < this.form.detail.length; i++) {
        if (!this.form.detail[i].type) {
          this.$message.error('请输入开票类型');
          return false;
        }
        // 常规发票必须选择项目id
        if (!this.isPreReceived && !this.form.detail[i].projectid) {
          this.$message.error('请选择项目');
          return false;
        }
        // 预收款发票必须选择虚拟项目id
        if (this.isPreReceived && !_.isNumber(this.form.detail[i].virtual_project_id)) {
          this.$message.error('请选择项目');
          return false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.form.detail[i].cost_type)) {
          this.$message.error('请输入开票名称');
          return false;
        }

        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.form.detail[i].tax_type)) {
          this.$message.error('请选择含税未税金额');
          return false;
        }

        if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(this.form.detail[i].tax_rate)) {
          this.$message.error('请输入正确的税率');
          return false;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_9__utils_regExp__["a" /* regType */])('money').test(Math.abs(this.form.detail[i].untaxed_amount))) {
          this.$message.error('\u7B2C' + (i + 1) + '\u884C,\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u672A\u7A0E\u91D1\u989D\u6570\u5B57,\u5C0F\u6570\u90E8\u5206\u81F3\u591A\u4FDD\u7559\u4E24\u4F4D\u5C0F\u6570');
          return false;
        }

        if (!Object(__WEBPACK_IMPORTED_MODULE_9__utils_regExp__["a" /* regType */])('money').test(Math.abs(this.form.detail[i].total))) {
          this.$message.error('\u7B2C' + (i + 1) + '\u884C,\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4EF7\u7A0E\u5408\u8BA1\u91D1\u989D\u6570\u5B57,\u5C0F\u6570\u90E8\u5206\u81F3\u591A\u4FDD\u7559\u4E24\u4F4D\u5C0F\u6570');
          return false;
        }

        if (this.taxed_total_amount * this.form.detail[i].total < 0) {
          this.$message.error('开票详情中价税合计金额不得同时出现正负数据');
          return false;
        }

        if (this.form.detail[i].complete_rate > 0 && !Object(__WEBPACK_IMPORTED_MODULE_9__utils_regExp__["a" /* regType */])('money').test(this.form.detail[i].complete_rate)) {
          this.$message.error('请输入正确的项目完成率');
          return false;
        }
      }
      var deductionTaxedAmountTotal = 0;
      for (var _i2 = 0; _i2 < this.form.deduction_detail.length; _i2++) {
        if (!this.form.deduction_detail[_i2].project_id) {
          this.$message.error('请选择抵扣申请项目');
          return false;
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_9__utils_regExp__["a" /* regType */])('money').test(Math.abs(this.form.deduction_detail[_i2].deduction_amount)) || Math.abs(this.form.deduction_detail[_i2].deduction_amount) === 0) {
          this.$message.error('请输入正确的抵扣申请含税金额');
          return false;
        }
        if (this.form.deduction_detail[_i2].attached_file.length < 1) {
          this.$message.error('请上传抵扣申请附件');
          return false;
        }
        if (!this.form.deduction_detail[_i2].status || [1, 2, 3].includes(this.form.deduction_detail[_i2].status * 1)) {
          deductionTaxedAmountTotal += Number(this.form.deduction_detail[_i2].deduction_amount);
        }
        delete this.form.deduction_detail[_i2].log;
      }
      if (Math.abs(deductionTaxedAmountTotal) > Math.abs(this.taxed_total_amount)) {
        this.$message.error('抵扣金额总和不得大于价税合计总计金额');
        return false;
      }

      // 未税金额合计>=1万元，自动在抄送人增加管理员Sam Huang/59
      if (this.untaxed_total_amount >= 10000) {
        this.form.cc.push(59);
      }
      // 开票主体为小零，所有开票抄送Irene/65，未税金额>=10W 时追加Fenix/1
      if (this.form.subject === 1) {
        this.form.cc.push(65);
        this.form.cc.push(753); // 抄送追加 ken zhang
        // 2021-07-23 取消追加抄送人 Fenix/1
        // if (this.untaxed_total_amount >= 100000) {
        //  this.form.cc.push(1)
        // }
      }

      this.form.cc = _.uniq(this.form.cc);

      if (this.strLengthCount(this.form.invoice_remark) > 184) {
        this.$message.error('百旺开票服务限制，发票备注不得大于184个字符, 汉字和全角字符占用2个长度');
        return false;
      }

      return true;
    },
    computeTotal: function computeTotal(index, taxRate, untaxedAmount) {
      var totalAmount = RMB(0.01).multiply(RMB(taxRate)).add(1).multiply(untaxedAmount);
      this.form.detail[index].total = totalAmount.value;
      this.form.detail[index].tax_amount = totalAmount.subtract(RMB(untaxedAmount));
    },
    computeUntaxedAmount: function computeUntaxedAmount(index, taxRate, total) {
      var untaxedAmount = RMB(total).divide(RMB(0.01).multiply(RMB(taxRate)).add(1));
      this.form.detail[index].untaxed_amount = untaxedAmount.value;
      this.form.detail[index].tax_amount = RMB(total).subtract(untaxedAmount).value;
    },
    onUploadedReport: function onUploadedReport(report, index) {
      this.$set(this.form.detail[index], 'uploaded', !!report);
      this.$set(this.form.detail[index], 'report', report);
    },
    uploadReport: function uploadReport(itemIndex) {
      this.$refs.uploadReport.open(itemIndex);
      var files = this.form.detail[itemIndex].report ? [this.form.detail[itemIndex].report] : [];
      this.reportFiles = files;
    },

    strLengthCount: function strLengthCount(str) {
      // eslint-disable-next-line no-control-regex
      var banjiao = this.countArr(str.match(/[\u0000-\u00ff]/g));
      var quanjiao = this.countArr(str.match(/[\uff00-\uffff]/g));
      var chinese = this.countArr(str.match(/[\u4e00-\u9fa5]/g));
      return banjiao + (quanjiao + chinese) * 2;
    },
    countArr: function countArr(arr) {
      return arr == null ? 0 : arr.length;
    },
    defaultDetailObj: function defaultDetailObj() {
      return {
        id: 0,
        type: '市场调查',
        projectid: '',
        virtual_project_id: '',
        do_number: '',
        memo: '',
        complete_rate: '',
        modifyRate: true,
        budget: 0,
        spec: '',
        unit: '',
        quantity: '',
        cost: 0,
        cost_type: null,
        untaxed_amount: 0,
        tax_rate: 6,
        total: 0,
        tax_amount: 0,
        report: null,
        uploaded: false,
        tax_type: 1
      };
    }
  })
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceApplyForm_vue__ = __webpack_require__(2760);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125aa4e3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceApplyForm_vue__ = __webpack_require__(4415);
function injectStyle (ssrContext) {
  __webpack_require__(4408)
  __webpack_require__(4410)
  this["$style"] = __webpack_require__(4412)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-125aa4e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceApplyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125aa4e3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceApplyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 4408:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4409);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5cbc64b2", content, true, {});

/***/ }),

/***/ 4409:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceApplyForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4410:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("89e5ad14", content, true, {});

/***/ }),

/***/ 4411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".col-center[data-v-125aa4e3]{text-align:center}.receipt-info[data-v-125aa4e3]{display:block;margin-bottom:10px}.receipt-info-text[data-v-125aa4e3]{margin-right:8px;font-weight:700}.receipt-info-block[data-v-125aa4e3]{width:470px;margin-bottom:30px;margin-left:70px;border-radius:5px;border:2px solid transparent;background-clip:padding-box;background-color:hsla(0,0%,50%,.1);padding:5px 10px}.invoice-row[data-v-125aa4e3]{min-height:80px}.invoice-row .el-col[data-v-125aa4e3]{line-height:40px;text-align:center}", "", {"version":3,"sources":["/workspace/src/views/invoice-apply/pages/InvoiceApplyForm.vue"],"names":[],"mappings":"AACA,6BAA6B,iBAAiB,CAC7C,AACD,+BAA+B,cAAc,kBAAkB,CAC9D,AACD,oCAAoC,iBAAiB,eAAgB,CACpE,AACD,qCAAqC,YAAY,mBAAmB,iBAAiB,kBAAkB,6BAA6B,4BAA4B,mCAAuC,gBAAgB,CACtN,AACD,8BAA8B,eAAe,CAC5C,AACD,sCAAsC,iBAAiB,iBAAiB,CACvE","file":"InvoiceApplyForm.vue","sourcesContent":["\n.col-center[data-v-125aa4e3]{text-align:center\n}\n.receipt-info[data-v-125aa4e3]{display:block;margin-bottom:10px\n}\n.receipt-info-text[data-v-125aa4e3]{margin-right:8px;font-weight:bold\n}\n.receipt-info-block[data-v-125aa4e3]{width:470px;margin-bottom:30px;margin-left:70px;border-radius:5px;border:2px solid transparent;background-clip:padding-box;background-color:rgba(128,128,128,0.1);padding:5px 10px\n}\n.invoice-row[data-v-125aa4e3]{min-height:80px\n}\n.invoice-row .el-col[data-v-125aa4e3]{line-height:40px;text-align:center\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4412:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("017f6028", content, true, {});

/***/ }),

/***/ 4413:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"InvoiceApplyForm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SjUploadModal__ = __webpack_require__(1942);


__WEBPACK_IMPORTED_MODULE_0__SjUploadModal__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__SjUploadModal__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__SjUploadModal__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__SjUploadModal__["a" /* default */]);

/***/ }),

/***/ 4415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/invoice-apply/table"}},[_vm._v("开票管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),(_vm.showErrorMsg)?[(_vm.detailErrorMsg)?_c('error-panel',{attrs:{"message":_vm.detailErrorMsg,"show-back":""}}):_vm._e()]:[_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("开票申请（一次开票申请仅对应一张发票）")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"开票类别","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},on:{"change":_vm.changeIssuedType},model:{value:(_vm.form.issued_type),callback:function ($$v) {_vm.$set(_vm.form, "issued_type", $$v)},expression:"form.issued_type"}},_vm._l((_vm.options.issued_type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":Number(item.value)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"申请描述","prop":"desc"}},[_c('el-input',{attrs:{"placeholder":"请输入申请描述"},model:{value:(_vm.form.desc),callback:function ($$v) {_vm.$set(_vm.form, "desc", $$v)},expression:"form.desc"}})],1),_vm._v(" "),(_vm.isPreReceived)?_c('el-form-item',{attrs:{"label":"BD","prop":"bd"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.bd),callback:function ($$v) {_vm.$set(_vm.form, "bd", $$v)},expression:"form.bd"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"BO审批","prop":"bu_approver"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status_lists: [1, 2]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.bu_approver),callback:function ($$v) {_vm.$set(_vm.form, "bu_approver", $$v)},expression:"form.bu_approver"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"抄送人","prop":"cc"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","multiple-limit":_vm.multipleLimit,"id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入管理员名称搜索","query-request":function (_){ return _vm.getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 5], status_lists: [1, 2]})); },"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.form.cc),callback:function ($$v) {_vm.$set(_vm.form, "cc", $$v)},expression:"form.cc"}})],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"填写开票注意的事项，如：单位、单价、按含税或未税金额开等事项","placement":"right"}},[_c('el-form-item',{attrs:{"label":"开票备注","prop":"memo"}},[_c('el-input',{attrs:{"placeholder":"输入开票需要的备注的内容"},model:{value:(_vm.form.memo),callback:function ($$v) {_vm.$set(_vm.form, "memo", $$v)},expression:"form.memo"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"添加附件","prop":"attached_file"}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"action":"","auto-upload":false,"on-change":function (file, fileList) {_vm.onChangeFile(file, fileList, this$1.form.attached_file)},"before-remove":function (file, fileList) {_vm.beforeRemove(file, fileList, this$1.form.attached_file)},"multiple":"","limit":20,"on-exceed":function (file, fileList) {_vm.handleExceed(file, fileList, 20)},"file-list":_vm.fileList,"accept":".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .doc, .docx, .xls, .xlsx, .ofd, .xml, .zip"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"附件上传确认开票的资料，有po单的需上传相应的po单","placement":"right"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击上传\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/OFD/XML/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式\n              ")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户名称","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户名称/编号搜索","query-request":function (_){ return _vm.getCustomerTable(Object.assign(_, {type: 'all'})); },"find-request":_vm.getCustomerDetail},on:{"change":_vm.onChangeCustomerId},model:{value:(_vm.form.customerid),callback:function ($$v) {_vm.$set(_vm.form, "customerid", $$v)},expression:"form.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"抬头","prop":"receipt_info_id"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},on:{"change":function () { return _vm.form.pay_condition_id = null; }},model:{value:(_vm.form.receipt_info_id),callback:function ($$v) {_vm.$set(_vm.form, "receipt_info_id", $$v)},expression:"form.receipt_info_id"}},_vm._l((_vm.receiptOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.receiptInfo)?_c('div',{staticClass:"receipt-info-block"},[_c('h3',[_vm._v("客户开票信息")]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("公司名称: ")]),_vm._v(_vm._s(_vm.receiptInfo.company_name))]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("开户行及账号: ")]),_vm._v(_vm._s(_vm.receiptInfo.bank_info))]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("地址及电话: ")]),_vm._v(_vm._s(_vm.receiptInfo.address_phone))]),_vm._v(" "),_c('span',{staticClass:"receipt-info"},[_c('span',{staticClass:"receipt-info-text"},[_vm._v("税号: ")]),_vm._v(_vm._s(_vm.receiptInfo.tax_number))])]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账期","prop":"pay_condition_id"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"客户合同约定的回款账期"},model:{value:(_vm.form.pay_condition_id),callback:function ($$v) {_vm.$set(_vm.form, "pay_condition_id", $$v)},expression:"form.pay_condition_id"}},_vm._l((_vm.collectConditionOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发票类别","prop":"type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}},_vm._l((_vm.options.type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票主体","prop":"subject"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},on:{"change":function($event){_vm.subjectErrorMessage = ''}},model:{value:(_vm.form.subject),callback:function ($$v) {_vm.$set(_vm.form, "subject", $$v)},expression:"form.subject"}},_vm._l((_vm.availableSubjects),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1),_vm._v(" "),(_vm.subjectErrorMessage)?_c('div',{staticStyle:{"color":"#F56C6C","font-size":"12px","margin-top":"3px","line-height":"1","padding":"2px 0","white-space":"nowrap","width":"100%"}},[_vm._v("\n              "+_vm._s(_vm.subjectErrorMessage)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"开票金额依据","prop":"invoice_tax_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.form.invoice_tax_type),callback:function ($$v) {_vm.$set(_vm.form, "invoice_tax_type", $$v)},expression:"form.invoice_tax_type"}},_vm._l((_vm.options.tax_type),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"发票备注","prop":"invoice_remark"}},[_c('el-input',{attrs:{"placeholder":"此备注为发票右下角备注信息！！！"},model:{value:(_vm.form.invoice_remark),callback:function ($$v) {_vm.$set(_vm.form, "invoice_remark", $$v)},expression:"form.invoice_remark"}})],1)],1)])]),_vm._v(" "),_c('div',[(!_vm.isPreReceived)?_c('el-button',{staticStyle:{"margin-left":"30px","margin-bottom":"30px"},attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onAddDetail()}}},[_vm._v("添加\n      ")]):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("序号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("开票类型")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("项目名称/编号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("项目完成率 %")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("DO/PO单号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("项目预算")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("项目成本")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("规格型号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("单位")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("数量")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":2}},[_vm._v("开票名称")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("未税金额")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("税率 %")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("税额")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("价税合计")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.form.detail),function(detailItem,itemIndex){return _c('el-row',{key:itemIndex,staticClass:"invoice-row",staticStyle:{"margin-top":"5px"}},[_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":1}},[_vm._v("\n          "+_vm._s(itemIndex+1)+"\n        ")]),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(detailItem.type),callback:function ($$v) {_vm.$set(detailItem, "type", $$v)},expression:"detailItem.type"}})],1),_vm._v(" "),(!_vm.isPreReceived)?_c('el-col',{key:"project_id",attrs:{"span":2}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","disabled":!_vm.form.customerid,"query-request":function (_){ return _vm.getProjectTable(Object.assign({customerid: _vm.form.customerid, status: _vm.statusEnum.ACHIEVEMENT}, _)); },"find-request":_vm.getProjectDetail},on:{"change":function($event){return _vm.changeProject(detailItem.projectid, itemIndex)}},model:{value:(detailItem.projectid),callback:function ($$v) {_vm.$set(detailItem, "projectid", $$v)},expression:"detailItem.projectid"}})],1):_vm._e(),_vm._v(" "),(_vm.isPreReceived)?_c('el-col',{key:"virtual_project_id",attrs:{"span":2}},[_c('remote-select',{ref:"virtual",refInFor:true,staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入虚拟项目名称/编号搜索","disabled":!_vm.form.customerid,"query-request":function (_){ return _vm.getReceiptVirtualProjectTable(Object.assign({customerid: _vm.form.customerid, append_new_info: true}, _)); },"find-request":_vm.getRemoteSelectVirtualProjectInfo},model:{value:(detailItem.virtual_project_id),callback:function ($$v) {_vm.$set(detailItem, "virtual_project_id", $$v)},expression:"detailItem.virtual_project_id"}})],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[(detailItem.modifyRate)?_c('el-input',{attrs:{"disabled":_vm.isPreReceived,"placeholder":"项目完成率"},model:{value:(detailItem.complete_rate),callback:function ($$v) {_vm.$set(detailItem, "complete_rate", $$v)},expression:"detailItem.complete_rate"}}):_vm._e(),_vm._v(" "),(!detailItem.modifyRate)?_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(detailItem.complete_rate))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-input',{attrs:{"disabled":_vm.isPreReceived,"placeholder":"请输入"},model:{value:(detailItem.do_number),callback:function ($$v) {_vm.$set(detailItem, "do_number", $$v)},expression:"detailItem.do_number"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center","overflow":"auto"},attrs:{"span":2}},[_c('span',[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm._f("seperateThousandsToFixed")(detailItem.budget,2)))])]),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center","overflow":"auto"},attrs:{"span":2}},[_c('span',[_vm._v(_vm._s(_vm.symbol)+_vm._s(_vm._f("seperateThousandsToFixed")(detailItem.cost,2)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(detailItem.spec),callback:function ($$v) {_vm.$set(detailItem, "spec", $$v)},expression:"detailItem.spec"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(detailItem.unit),callback:function ($$v) {_vm.$set(detailItem, "unit", $$v)},expression:"detailItem.unit"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input',{attrs:{"placeholder":"请输入"},model:{value:(detailItem.quantity),callback:function ($$v) {_vm.$set(detailItem, "quantity", $$v)},expression:"detailItem.quantity"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-select',{attrs:{"placeholder":"请选择"},on:{"change":function (id) { return _vm.changeCostType(id, itemIndex); }},model:{value:(detailItem.cost_type),callback:function ($$v) {_vm.$set(detailItem, "cost_type", $$v)},expression:"detailItem.cost_type"}},_vm._l((_vm.costTypeOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.full_name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('el-input',{attrs:{"placeholder":"请输入","disabled":!_vm.form.invoice_tax_type || _vm.form.invoice_tax_type === 1},on:{"input":function($event){return _vm.computeTotal(itemIndex, detailItem.tax_rate, detailItem.untaxed_amount)}},model:{value:(detailItem.untaxed_amount),callback:function ($$v) {_vm.$set(detailItem, "untaxed_amount", $$v)},expression:"detailItem.untaxed_amount"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('span',[_vm._v(_vm._s(detailItem.tax_rate))])]),_vm._v(" "),_c('el-col',{attrs:{"span":1}},[_c('span',[_vm._v(_vm._s(_vm._f("seperateThousandsToFixed")((detailItem.total - detailItem.untaxed_amount),2)))])]),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":1}},[_c('el-input',{attrs:{"placeholder":"请输入","disabled":!_vm.form.invoice_tax_type || _vm.form.invoice_tax_type === 2},on:{"input":function($event){return _vm.computeUntaxedAmount(itemIndex, detailItem.tax_rate, detailItem.total)}},model:{value:(detailItem.total),callback:function ($$v) {_vm.$set(detailItem, "total", $$v)},expression:"detailItem.total"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-bottom":"5px"}},[_c('el-button',{staticStyle:{"display":"block"},attrs:{"type":"danger","size":"mini","icon":"el-icon-delete"},on:{"click":function($event){return _vm.onDelItem(itemIndex)}}},[_vm._v("删除\n            ")])],1),_vm._v(" "),_c('el-row',[_c('el-button',{staticStyle:{"display":"block"},attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.uploadReport(itemIndex)}}},[_vm._v("上传项目报告\n              "),(detailItem.uploaded)?_c('i',{staticClass:"el-icon-upload-success el-icon-circle-check"}):_vm._e()])],1)],1)],1)})],2),_vm._v(" "),_c('div',{staticStyle:{"margin":"30px 0 0 0"}},[_c('el-row',[_c('el-col',{staticClass:"col-center",attrs:{"span":4,"offset":10}},[_vm._v("未税金额总计："+_vm._s(_vm.symbol)+" "+_vm._s(_vm._f("seperateThousandsToFixed")(_vm.untaxed_total_amount,2))+"\n        ")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":3}},[_vm._v("税额合计："+_vm._s(_vm.symbol)+" "+_vm._s(_vm._f("seperateThousandsToFixed")(_vm.tax_total_amount,2))+"\n        ")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":4}},[_vm._v("价税合计总计："+_vm._s(_vm.symbol)+" "+_vm._s(_vm._f("seperateThousandsToFixed")(_vm.taxed_total_amount,2))+"\n        ")])],1)],1),_vm._v(" "),(_vm.isPreReceived)?_c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"在预收款开票申请时可以同时添加该预收款的抵扣申请，抵扣申请将于开票状态变为已签收时生效","placement":"right"}},[_c('el-button',{staticStyle:{"margin-left":"30px","margin-bottom":"30px"},attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.onAddDeductionDetail()}}},[_vm._v("添加抵扣申请\n        ")])],1),_vm._v(" "),_c('el-row',{attrs:{"hidden":_vm.form.deduction_detail.length === 0}},[_c('el-col',{staticClass:"col-center",attrs:{"span":1}},[_vm._v("序号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":6}},[_vm._v("项目名称/编号")]),_vm._v(" "),_c('el-col',{staticClass:"col-center",attrs:{"span":6}},[_vm._v("抵扣含税金额")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.form.deduction_detail),function(detailItem,itemIndex){return _c('el-row',{key:itemIndex,staticClass:"invoice-row",staticStyle:{"margin-top":"5px"}},[_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":1}},[_vm._v("\n          "+_vm._s(itemIndex + 1)+"\n        ")]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('remote-select',{staticClass:"width-max",attrs:{"disabled":_vm.isDeductionItemDisabled(detailItem) || !_vm.form.customerid,"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":function (_){ return _vm.getProjectTable(Object.assign({status: _vm.statusEnum.ACHIEVEMENT, customerid: _vm.form.customerid}, _)); },"find-request":_vm.getProjectDetail},model:{value:(detailItem.project_id),callback:function ($$v) {_vm.$set(detailItem, "project_id", $$v)},expression:"detailItem.project_id"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"center"},attrs:{"span":6}},[_c('el-input',{attrs:{"disabled":_vm.isDeductionItemDisabled(detailItem),"placeholder":"请输入抵扣含税金额"},model:{value:(detailItem.deduction_amount),callback:function ($$v) {_vm.$set(detailItem, "deduction_amount", $$v)},expression:"detailItem.deduction_amount"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-upload',{ref:"upload",refInFor:true,staticClass:"upload-demo",attrs:{"disabled":_vm.isDeductionItemDisabled(detailItem),"action":"","auto-upload":false,"on-change":function (file, fileList) {_vm.onChangeFile(file, fileList, _vm.form.deduction_detail[itemIndex].attached_file)},"before-remove":function (file, fileList) {_vm.beforeRemove(file, fileList, _vm.form.deduction_detail[itemIndex].attached_file)},"multiple":"","limit":20,"on-exceed":function (file, fileList) {_vm.handleExceed(file, fileList, 20)},"file-list":_vm.form.deduction_detail[itemIndex].attached_file,"accept":".jpg, .jpeg, .png, .pdf, .eml"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"只能上传PNG/JPG/PDF/EML文件，允许上传多张","placement":"right"}},[_c('el-button',{attrs:{"size":"small","disabled":_vm.isDeductionItemDisabled(detailItem),"type":"primary"}},[_vm._v("上传抵扣审批附件\n              ")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-bottom":"5px"}},[_c('el-button',{staticStyle:{"display":"block"},attrs:{"type":"danger","disabled":_vm.isDeductionItemDisabled(detailItem),"size":"mini","icon":"el-icon-delete"},on:{"click":function($event){return _vm.onDelDeductionItem(itemIndex)}}},[_vm._v("删除\n            ")])],1)],1)],1)})],2):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 auto","text-align":"center","margin-top":"70px"}},[_c('el-button',{on:{"click":function($event){return _vm.$router.push({name: '开票管理'})}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("保存\n      ")])],1)],1)],_vm._v(" "),_c('sj-upload-modal',{ref:"uploadReport",attrs:{"validate-file":true,"files":_vm.reportFiles,"showClearBtn":false,"file-extension":"zip","file-max-size":100 * 1024 * 1024,"request":"uploadReportFile","tip":"若文件大于100M，请以网盘链接的形式，添加压缩文件上传","title":"上传项目报告"},on:{"uploaded":_vm.onUploadedReport}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/invoice-apply-form.a9808ddf6bed1ebe97e5.js